// extracted by mini-css-extract-plugin
export default {"featureTable":"casita-features_featureTable__Wn4+I","featureRow":"casita-features_featureRow__MeeAy"};